import { Edit } from "@refinedev/mui";
import {
  Box,
  TextField,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import { useForm } from "@refinedev/react-hook-form";

import { IResourceComponentsProps } from "@refinedev/core";
import { useParams } from "react-router-dom";
import React from "react";

export const DiscountEdit: React.FC<IResourceComponentsProps> = () => {
  const params = useParams();

  const {
    saveButtonProps,
    refineCore: { formLoading },
    register,
    formState: { errors },
  } = useForm({
    refineCoreProps: {
      resource: "discounts",
      action: "edit",
      id: params?.id,
    },
  });

  return (
    <Edit isLoading={formLoading} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <Grid container spacing={2}>
          {/* Name */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <TextField
                  {...register("name", {
                    required: "This field is required",
                  })}
                  label="Name"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  error={!!errors.name}
                  helperText={errors.name?.message as string}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Description */}
          <Grid item xs={12} md={6}>
            <Card>
              <CardContent>
                <TextField
                  {...register("description")}
                  label="Description"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  multiline
                  rows={3}
                />
              </CardContent>
            </Card>
          </Grid>

          {/* Note: Type cannot be edited in Stripe */}
          <Box sx={{ p: 2, bgcolor: 'warning.light', borderRadius: 1, margin: 2, marginRight: 0 }}>
            <strong>Note:</strong> Discount type, amount/percentage, currency, expiration date, max redemptions, and product restrictions cannot be modified after creation due to Stripe limitations. Only name and description can be updated.
          </Box>
        </Grid>
      </Box>
    </Edit>
  );
};
